import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faX } from '@fortawesome/free-solid-svg-icons';

const Formula = ({ onButtonPress }) => {
  return (
    <div className="py-5 px-1 px-sm-5 bg-light">
      <div className="container">
        <div className="d-flex align-items-center justify-content-center">
          <h1 className="pb-2 font-weight-bold text-center">
            The Ideal LinkedIn Headline Formula
          </h1>
        </div>
        <h6 className="text-center">
          Using data from helping thousands of job seekers optimize their
          LinkedIn profile, this is the headline formula that we recommend in
          order to see the most success:
        </h6>

        <div className="row mt-4 d-flex align-items-center">
          <div className="col-12 col-md-3 col-lg-2">
            <h5 className="font-weight-bold text-primary">Formula:</h5>
          </div>
          <div className="col">
            <h5 className="font-weight-bold">
              [Job Title] | [Skill 1], [Skill 2], [Skill 3] | I Help [Company
              Type] [Insert Unique Value Proposition With Measurable Metrics]
            </h5>
          </div>
        </div>

        <div className="row my-4 d-flex align-items-center">
          <div className="col-12 col-md-3 col-lg-2">
            <h5 className="font-weight-bold text-primary">Example:</h5>
          </div>
          <div className="col">
            <h5 className="font-weight-bold">
              Data Analyst | R, Tableau, Power BI | I Help eCommerce Companies
              Leverage Big Data To Drive A 500% Increase In Customer Retention
            </h5>
          </div>
        </div>

        <div className="d-flex flex-column w-sm-50 mx-auto">
          <button
            onClick={() =>
              onButtonPress(new Date().setDate(new Date().getDate() + 7))
            }
            className="btn btn-primary mx-auto my-2 d-flex w-100 row align-items-center"
          >
            <div className="col-md-1 d-none d-md-block">
              <div className="rounded-circle small-circle bg-white d-flex align-items-center justify-content-center">
                <FontAwesomeIcon color="#0072ce" size="1x" icon={faCheck} />
              </div>
            </div>
            <span className="col font-override">Got it! Don't Show Me This For 7 Days</span>
          </button>
          <button
            onClick={() =>
              onButtonPress(new Date().setDate(new Date().getDate() + 365))
            }
            className="btn btn-2 mx-auto my-2 d-flex w-100 row align-items-center"
          >
            <div className="col-md-1 d-none d-md-block">
              <div className="rounded-circle small-circle bg-primary d-flex align-items-center justify-content-center">
                <FontAwesomeIcon color="white" size="1x" icon={faX} />
              </div>
            </div>
            <span className="col font-override">Don't Show Me This Message Again</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Formula;
